export default __webpack_public_path__ + "static/media/integrity-multicure-provisorisches-material.f3d71bde.png";